var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.iconName,style:({height: _vm.size, width: _vm.size})})
}
var staticRenderFns = []

export { render, staticRenderFns }